import { useContext, useState } from "react";
import { Button, Typography } from "@material-ui/core";
import { AuthContext } from "../../../../../../../context/context";
import { InputFile } from "../fields";
import useStyles from "./styles";
import { AltaContext, EndosoContext } from "../../../../../context";
import { FilesViewer } from "../filesViewer";
import { AlertModal } from "../../../../../../../shared/components";
export const UploadExcel = ({ returntoMain }) => {
  const classes = useStyles();
  const { setTimer, setPersons, persons } = useContext(AuthContext);
  const { filesResponse, spinner, alertData, setAlertData } =
    useContext(EndosoContext);
  const { setFile } = useContext(AltaContext);
  const [confirming, setConfirming] = useState(false);

  const handleChange = (files) => {
    setTimer(0);
    setPersons(files[0]);
    setFile(files[0]);
  };

  const confirmModal = (
    <AlertModal
      open={Boolean(alertData)}
      loading={confirming}
      close={() => {
        if (!confirming) setAlertData(undefined);
      }}
      SuccessText={alertData?.successText || "Continuar"}
      CancelText={alertData?.cancelText || "Cancelar"}
      message={alertData?.message}
      title={"Atención"}
      success={async () => {
        setConfirming(true);
        try {
          await alertData?.action?.();
        } finally {
          setConfirming(false);
          setAlertData(undefined);
        }
      }}
    />
  );

  if (filesResponse.length) return <FilesViewer />;

  if (spinner) return <></>;

  return (
    <div>
      {confirmModal}
      <Typography className={classes.title} variant="h6">
        Agregar archivo de asegurados
      </Typography>
      <InputFile
        required
        label="Archivo de asegurados"
        onChange={handleChange}
        name={persons?.name}
      />
      <Typography className={classes.caption} variant="caption">
        Recuerda que solo se permiten documentos excel (.xlsx)
      </Typography>
      <Button
        className={classes.backButton}
        variant="text"
        onClick={() => {
          setTimer(0);
          returntoMain();
        }}
      >
        Regresar
      </Button>
    </div>
  );
};
